import React from "react";
import Grid from "@material-ui/core/Grid";
import RecentModulesCard from "../../components/dashboard/RecentModulesCard";
import CreatorUsersCard from "./CreatorUsersCard";
import CspCard from "./CspCard";
import CspProjectSubmissionCard from "../../components/dashboard/CspProjectSubmissionCard";
import { Box, useMediaQuery } from "@material-ui/core";
import ItemsCountCard from "./ItemsCountCard";
import { dateRanges } from "../../components/dashboard/DateRangeSelect";
import UnreachableOrganizationMediaCard from "./UnreachableOrganizationMediaCard";
import ContentGroupsCard from "./ContentGroupsCard";

const CreatorAdminDashboard = () => {
  const isCreatorAdminDashboardMd = useMediaQuery(theme =>
    theme.breakpoints.up("creatorAdminDashboardMd"),
  );
  const isMd = useMediaQuery(theme => theme.breakpoints.up("md"));
  return (
    <Grid container spacing={5}>
      <Grid item xs={12} md={8}>
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Grid container spacing={5}>
              <Grid item xs={12} sm={5}>
                <UnreachableOrganizationMediaCard />
              </Grid>

              <Grid item sm={4}>
                <RecentModulesCard />
              </Grid>

              <Grid item sm={3}>
                <Box height="100%" minHeight={390}>
                  <Grid container direction="column" spacing={5}>
                    <Grid item>
                      <ItemsCountCard />
                    </Grid>

                    <Grid item>
                      <CreatorUsersCard />
                    </Grid>
                  </Grid>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <ContentGroupsCard
              limit={isCreatorAdminDashboardMd ? 6 : 5}
              title="Recently Updated Content Groups"
              range={dateRanges.last_30}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} md={4}>
        <Grid container direction={isMd ? "column" : "row"} spacing={5}>
          <Grid item sm={8} md>
            <CspProjectSubmissionCard
              title="CSP Submissions in Last 2 Weeks"
              range={dateRanges.last_14}
            />
          </Grid>
          <Grid item sm={4} md>
            <CspCard />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default CreatorAdminDashboard;
